import { RootState } from '@src/store';
import { IChecklistInitialState } from './types';
import { createSelector } from '@reduxjs/toolkit';

const ChecklistReducer = (state: RootState): IChecklistInitialState => state.ChecklistPageReducer;
const ChecklistState = createSelector([ChecklistReducer], (state) => state);

export const selectEquipmentStatus = createSelector([ChecklistState], (state) => state.equipmentStatus);

export const selectJoystickStatus = (serialNumber: string) => 
  createSelector([ChecklistState], (state) => state.equipmentStatus[serialNumber]?.joystickConnected ?? false);

export const selectJoystickId = (serialNumber: string) => 
  createSelector([ChecklistState], (state) => state.equipmentStatus[serialNumber]?.joystickId ?? null);

export const selectCameraStatus = (serialNumber: string) => 
  createSelector([ChecklistState], (state) => state.equipmentStatus[serialNumber]?.cameraConnected ?? false);

export const selectEquipmentStatusBySerial = (serialNumber: string) =>
  createSelector([ChecklistState], (state) => state.equipmentStatus[serialNumber] ?? {
    joystickConnected: false,
    joystickId: null,
    cameraConnected: false,
  });

